import {
  publishSite as publicPublishSite,
  deployStandalonePages as publicDeployStandalonePages,
  duplicateSite as publicDuplicateSite,
  bulkDeleteSite as publicBulkDeleteSite,
} from './site-actions-v1-site-actions-site-actions.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const publishSite: MaybeContext<
  BuildRESTFunction<typeof publicPublishSite> & typeof publicPublishSite
> = /*#__PURE__*/ createRESTModule(publicPublishSite);
export const deployStandalonePages: MaybeContext<
  BuildRESTFunction<typeof publicDeployStandalonePages> &
    typeof publicDeployStandalonePages
> = /*#__PURE__*/ createRESTModule(publicDeployStandalonePages);
export const duplicateSite: MaybeContext<
  BuildRESTFunction<typeof publicDuplicateSite> & typeof publicDuplicateSite
> = /*#__PURE__*/ createRESTModule(publicDuplicateSite);
export const bulkDeleteSite: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteSite> & typeof publicBulkDeleteSite
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteSite);

export {
  EmptyEntity,
  PublishSiteRequest,
  PublishSiteResponse,
  DeployStandalonePagesRequest,
  DeployStandalonePagesResponse,
  DuplicateSiteRequest,
  DuplicateSiteResponse,
  BulkDeleteSiteRequest,
  BulkDeleteSiteResponse,
  BulkSiteResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  RenameSiteRequest,
  RenameSiteResponse,
  ValidateSiteNameRequest,
  ValidateSiteNameResponse,
  UnpublishSiteRequest,
  UnpublishSiteResponse,
  MoveSiteToTrashRequest,
  MoveSiteToTrashResponse,
  RestoreSiteFromTrashRequest,
  RestoreSiteFromTrashResponse,
  DeleteSiteFromTrashRequest,
  DeleteSiteFromTrashResponse,
  CreateAndAttachChildRequest,
  CreateAndAttachChildResponse,
  DuplicateSiteOptions,
} from './site-actions-v1-site-actions-site-actions.universal.js';
export {
  PublishSiteApplicationErrors,
  DeployStandalonePagesApplicationErrors,
} from './site-actions-v1-site-actions-site-actions.universal.js';
